import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-descripcion',
  templateUrl: './dialog-descripcion.component.html',
  styleUrls: ['./dialog-descripcion.component.css']
})
export class DialogDescripcionComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: string) { }

  openDialog() {
    this.dialog.open(DialogDescripcionComponent);
  }
  ngOnInit(): void {
  }

}
